import { z } from 'zod';

import {
  CursorPaginationMetaSchema,
  ListSortOrderSchema,
  PaginationSchema,
} from '../../../pagination.js';

import { RevisionPlanCompositionItemSchema } from './revision-plan.schemas.js';

export const RevisionPlanListSortFieldSchema = z.enum(['name', 'genericCount']);
export type RevisionPlanListSortField = z.infer<typeof RevisionPlanListSortFieldSchema>;

export const ListRevisionPlansQuerySchema = PaginationSchema.extend({
  q: z.preprocess(
    (val) => (typeof val === 'string' && val.trim() === '' ? undefined : val),
    z.string().trim().min(2).max(100).optional(),
  ),
  sort: RevisionPlanListSortFieldSchema.optional(),
  order: ListSortOrderSchema.optional(),
});

export const RevisionPlanListItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  genericCount: z.number().int(),
  items: z.array(RevisionPlanCompositionItemSchema),
  updatedAt: z.iso.datetime(),
});

export const ListRevisionPlansResponseSchema = z.object({
  items: z.array(RevisionPlanListItemSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListRevisionPlansQuery = z.infer<typeof ListRevisionPlansQuerySchema>;
export type RevisionPlanListItem = z.infer<typeof RevisionPlanListItemSchema>;
export type ListRevisionPlansResponse = z.infer<typeof ListRevisionPlansResponseSchema>;
